import { render } from "./role-form-page.vue?vue&type=template&id=09c48b38&scoped=true"
import script from "./role-form-page.vue?vue&type=script&lang=js"
export * from "./role-form-page.vue?vue&type=script&lang=js"

import "./role-form-page.vue?vue&type=style&index=0&id=09c48b38&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c48b38"]])

export default __exports__